var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-countdown-timer", {
    attrs: {
      "start-time": _vm.startTime,
      "end-time": _vm.endTime,
      interval: 1000,
      "start-label": "Until start:",
      "end-label": "Offer Expire:",
      "label-position": "begin",
      "end-text": "Event ended!",
      "day-txt": "days",
      "hour-txt": "hours",
      "minutes-txt": "minutes",
      "seconds-txt": "seconds",
    },
    on: {
      start_callback: function ($event) {
        return _vm.startCallBack("event started")
      },
      end_callback: function ($event) {
        return _vm.endCallBack("event ended")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "start-label",
        fn: function (scope) {
          return [
            scope.props.startLabel !== "" &&
            scope.props.tips &&
            scope.props.labelPosition === "begin"
              ? _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(_vm._s(scope.props.startLabel) + ":"),
                ])
              : _vm._e(),
            _vm._v(" "),
            scope.props.endLabel !== "" &&
            !scope.props.tips &&
            scope.props.labelPosition === "begin"
              ? _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(_vm._s(scope.props.endLabel) + ":"),
                ])
              : _vm._e(),
          ]
        },
      },
      {
        key: "countdown",
        fn: function (scope) {
          return [
            _c("span", [_vm._v(_vm._s(scope.props.days))]),
            _c("i", [_vm._v(_vm._s(scope.props.dayTxt))]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(scope.props.hours))]),
            _c("i", [_vm._v(_vm._s(scope.props.hourTxt))]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(scope.props.minutes))]),
            _c("i", [_vm._v(_vm._s(scope.props.minutesTxt))]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(scope.props.seconds))]),
            _c("i", [_vm._v(_vm._s(scope.props.secondsTxt))]),
          ]
        },
      },
      {
        key: "end-label",
        fn: function (scope) {
          return [
            scope.props.startLabel !== "" &&
            scope.props.tips &&
            scope.props.labelPosition === "end"
              ? _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(_vm._s(scope.props.startLabel) + ":"),
                ])
              : _vm._e(),
            _vm._v(" "),
            scope.props.endLabel !== "" &&
            !scope.props.tips &&
            scope.props.labelPosition === "end"
              ? _c("span", { staticStyle: { color: "blue" } }, [
                  _vm._v(_vm._s(scope.props.endLabel) + ":"),
                ])
              : _vm._e(),
          ]
        },
      },
      {
        key: "end-text",
        fn: function (scope) {
          return [
            _c("span", { staticStyle: { color: "green" } }, [
              _vm._v(_vm._s(scope.props.endText)),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }